import { motion } from "framer-motion";

const LINES = [
  { d: "M-40 362 C 150 248, 328 288, 490 86 S 630 -10, 690 30", w: 1, o: 0.5 },
  { d: "M-40 396 C 132 272, 312 312, 470 112 S 612 -28, 672 12", w: 1, o: 0.4 },
  { d: "M-25 344 C 160 232, 338 272, 498 72", w: 0.75, o: 0.34 },
  { d: "M-58 372 C 122 258, 302 296, 462 96", w: 0.75, o: 0.28 },
  { d: "M-30 356 C 155 240, 330 280, 492 82", w: 0.6, o: 0.22 },
  { d: "M-48 388 C 128 266, 308 304, 466 104", w: 0.6, o: 0.2 },
  { d: "M-52 366 C 126 252, 306 292, 468 92", w: 0.5, o: 0.17 },
  { d: "M-20 336 C 166 226, 344 264, 502 66", w: 0.5, o: 0.15 },
];
const LEAD = "M-40 380 C 140 260, 320 300, 480 100 S 620 -20, 680 20";

export const SwooshRibbons = ({ idPrefix, className = "", flip = false, inView = false, delay = 0 }) => {
  const anim = inView
    ? { initial: { pathLength: 0 }, whileInView: { pathLength: 1 }, viewport: { once: true, margin: "-60px" } }
    : { initial: { pathLength: 0 }, animate: { pathLength: 1 } };
  return (
    <svg
      className={`pointer-events-none ${className}`}
      viewBox="0 0 600 400"
      fill="none"
      aria-hidden="true"
      data-testid={`swoosh-${idPrefix}`}
      style={flip ? { transform: "scale(-1, -1)" } : undefined}
    >
      <defs>
        <linearGradient id={`${idPrefix}-chrome`} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#C9CDD3" stopOpacity="0" />
          <stop offset="0.45" stopColor="#D8DCE2" />
          <stop offset="1" stopColor="#C9CDD3" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={`${idPrefix}-red`} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#E5232D" stopOpacity="0" />
          <stop offset="0.5" stopColor="#F03A42" />
          <stop offset="1" stopColor="#E5232D" stopOpacity="0" />
        </linearGradient>
      </defs>
      <motion.path
        d={LEAD}
        stroke={`url(#${idPrefix}-red)`}
        strokeWidth={10}
        opacity={0.12}
        {...anim}
        transition={{ duration: 2.2, delay, ease: "easeInOut" }}
      />
      <motion.path
        d={LEAD}
        stroke={`url(#${idPrefix}-red)`}
        strokeWidth={1.6}
        opacity={0.9}
        {...anim}
        transition={{ duration: 2, delay, ease: "easeInOut" }}
      />
      {LINES.map((l, i) => (
        <motion.path
          key={i}
          d={l.d}
          stroke={`url(#${idPrefix}-chrome)`}
          strokeWidth={l.w}
          opacity={l.o}
          {...anim}
          transition={{ duration: 2, delay: delay + 0.15 + i * 0.12, ease: "easeInOut" }}
        />
      ))}
    </svg>
  );
};
